import { JWTProvider } from 'contexts/JWTContext';
import useJWTAuthentication from 'hooks/useJWTAuthentication';
import React, { ReactElement, ReactNode } from 'react';

const AuthJWTHandler = () => {
  useJWTAuthentication();
  return null;
};

const AuthProvider = ({ children }: {children: ReactNode}): ReactElement => (
  <JWTProvider>
    <AuthJWTHandler />
    {children}
  </JWTProvider>
);
export default AuthProvider;
